/**
 * The look of the timeline's tool-call groups, shared with the surfaces that
 * borrow it (Home's "Waiting on you"): the disclosure row (icon, muted label,
 * chevron that turns when open) and the indented body an opened entry shows.
 * MessagesTimeline draws its groups with these, so the two never drift.
 *
 * @module components/chat/timelineDisclosure
 */

/** The group's toggle row: full width, one line, hover wash, inset focus ring. */
export const TIMELINE_GROUP_TOGGLE_CLASS =
  "group/tool-group flex min-h-6 w-full cursor-pointer items-center gap-1.5 rounded-md px-0.5 py-0.5 text-left text-sm leading-relaxed transition-colors duration-150 hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring/70";

/** The 24px slot an entry's or group's glyph sits in. */
export const TIMELINE_ICON_SLOT_CLASS = "flex size-6 shrink-0 items-center justify-center";

/** The glyph itself, at the timeline's weight. */
export const TIMELINE_ICON_CLASS = "size-4 shrink-0 stroke-[1.8] opacity-70";

/** The chevron at the end of a toggle row; add `rotate-90` when open. */
export const TIMELINE_CHEVRON_CLASS =
  "size-3 shrink-0 text-icon-muted opacity-70 transition-transform duration-200";

/** An opened entry's body: indented under the glyph, hung from a hairline. */
export const TIMELINE_ENTRY_BODY_CLASS = "mt-1 ms-7 cursor-default border-s border-border/45 ps-3 pt-0.5";

/**
 * An expanding group's panel (for the product's CollapsiblePanel): height
 * and opacity travel together on the timeline's ease-out; nothing moves
 * under reduced motion.
 */
export const TIMELINE_DISCLOSURE_PANEL_CLASS =
  "h-(--collapsible-panel-height) overflow-hidden opacity-100 transition-[height,opacity] duration-200 ease-[cubic-bezier(0.22,1,0.36,1)] data-starting-style:h-0 data-starting-style:opacity-0 data-ending-style:h-0 data-ending-style:opacity-0 motion-reduce:transition-none";

/** A row's entrance inside an opened group; pair with a per-row `animationDelay` for the stagger. */
export const TIMELINE_ROW_ENTER_CLASS =
  "motion-safe:animate-[timeline-row-in_240ms_cubic-bezier(0.22,1,0.36,1)_both]";

/** The stagger between rows entering an opened group, in ms. */
export const TIMELINE_ROW_STAGGER_MS = 25;
